// src/modules/public/pages/RulesPage/index.js
import React from 'react';
import RulesView from '../../components/RulesView';
import { Container } from 'react-bootstrap';

const RulesPage = () => {
    return (
        <Container>
            <RulesView />
        </Container>
    );
};

export default RulesPage;
